export * from "-!../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./404.vue?vue&type=template&id=44b2bc6f&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/views/404.vue?vue&type=template&id=44b2bc6f&scoped=true&
// module id = 255
// module chunks = 1